<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    :okDisabled="true"
    @cancel="handleCancel"
    :cancelText="language['common.closeButton']">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="language['emp.empEntranceManager.managerWorkNo']">
              <a-input  v-model="queryParam.managerWorkNo"  allow-clear></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="language['emp.empEntranceManager.status']">
              <!--<a-input placeholder="请输入入口名称" v-model="queryParam.entranceName"></a-input>-->
              <j-dict-select-tag type="list" v-model="queryParam.status" dictCode="entrance_manager_status"   allow-clear/>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{language['common.searchButton']}}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{language['common.resetButton']}}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">{{language['common.insertButton']}}</a-button>
    </div>
    <div>
      <!--<div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>-->
      <a-table
        ref="table"
        bordered
        size="middle"
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="false"
        :loading="loading"
        @change="handleTableChange"
        :scroll="{x:true}"><!-- :scroll="{x:true}" -->

        <span slot="action" slot-scope="text, record">
            <a @click="handleFrozen(record,'1')" v-if="record.status=='0'">{{language['sys.dict.status.freeze']}}</a>
            <a @click="handleFrozen(record,'0')" v-else>{{language['common.thawButton']}}</a>
            <a-divider type="vertical" />
            <a-popconfirm :title="language['common.deleteConfirmInfo']" @confirm="() => remove(record)">
                <a>{{language['common.delete']}}</a>
            </a-popconfirm>
        </span>


      </a-table>
    </div>
    <emp-entrance-manager-user-modal ref="userModal" @ok="searchQuery"/>
  </j-modal>
</template>

<script>
  import { getAction,putAction,deleteAction } from '@/api/manage'
  import EmpEntranceManagerUserModal from './EmpEntranceManagerUserModal'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
    export default {
      components: {
        EmpEntranceManagerUserModal
      },
      name: "EmpEntranceManagerModal",
      mixins:[JeecgListMixin],
      data () {
        return {
          queryParam:{entranceId:""},
          entranceId:"",
          dataSource:[],
          columns:[
            {
              title: '#',
              dataIndex: '',
              key:'rowIndex',
              width:60,
              align:"center",
              customRender:function (t,r,index) {
                return parseInt(index)+1;
              }
            },
            {
              title:this.$store.getters.language['emp.empEntranceManager.managerWorkNo'],
              align:"left",
              dataIndex: 'managerWorkNo'
            },
            {
              title:this.$store.getters.language['emp.empEntranceManager.managerName'],
              align:"left",
              dataIndex: 'managerName'
            },
            {
              title:this.$store.getters.language['emp.empEntranceManager.status'],
              align:"left",
              dataIndex: 'status_dictText'
            },
            {
              title:this.$store.getters.language['emp.empEntranceManager.createTime'],
              align:"left",
              dataIndex: 'createTime',
              customRender:function (text,r) {
                return !text?"":(text.length>10?text.substr(0,10):text)
              }
            },
            {
              title: this.$store.getters.language['common.action'],
              dataIndex: 'action',
              align:"center",
              fixed:"right",
              width:147,
              scopedSlots: { customRender: 'action' }
            }
          ],
          title:this.$store.getters.language['emp.empCmsEntrance.managers'],
          width:1200,
          visible: false,
          disableSubmit: false,
          url: {
            list: "/hhemp/entranceManager/list"
          }
        }
      },
      computed: {
        language() {
          return this.$store.getters.language
        },
      },
      methods: {
        add () {
          this.visible=true
          this.$nextTick(()=>{
            this.$refs.realForm.add();
          })
        },
        edit (record) {
          this.visible=true
          this.queryParam.entranceId = record.id
          this.entranceId = record.id
          this.searchQuery()
        },
        close () {
          this.$emit('close');
          this.visible = false;
        },
        handleOk () {
          this.$refs.realForm.submitForm();
        },
        submitCallback(){
          this.$emit('ok');
          this.visible = false;
        },
        handleCancel () {
          this.close()
        },
        searchQuery(){
          this.dataSource = []
          getAction("/hhemp/entranceManager/list",this.queryParam).then(res=>{
            if(res.success){
              this.dataSource = res.result;
            }
          })
        },
        searchReset(){
          this.queryParam.managerWorkNo = '';
          this.queryParam.status = '';
          this.loadData(1);
        },
        handleAdd(){
          let list = [];
          if(this.dataSource.length>0){
            this.dataSource.forEach(item=>{
              let map = {};
              map.id = item.managerId;
              map.workNo = item.managerWorkNo
              map.realname = item.managerName
              list.push(map);
            })
          }
          this.$refs.userModal.edit(list,this.entranceId)
        },
        handleFrozen(record,v){
          record.status = v;
          putAction("/hhemp/entranceManager/empentrancemanager",record).then(res=>{
            if(res.success){
              this.searchQuery();
            }
          })
        },
        remove(record){
          deleteAction("/hhemp/entranceManager/empentrancemanager",{id:record.id}).then(res=>{
            if(res.success){
              this.searchQuery();
            }
          })
        }
      }
    }
</script>

<style scoped>

</style>